import { createSearchSortContext } from "@/components/Search/create-search-sort-context";

// i18n-tasks-use t('components.views.destinations.search.sort_travily_score')
// i18n-tasks-use t('components.views.destinations.search.sort_price_low_high')
// i18n-tasks-use t('components.views.destinations.search.sort_price_high_low')
const SORT_KEYS = [
  { value: "destinations", labelKey: "components.views.destinations.search.sort_travily_score" },
  { value: "destinations_price_asc", labelKey: "components.views.destinations.search.sort_price_low_high" },
  { value: "destinations_price_desc", labelKey: "components.views.destinations.search.sort_price_high_low" },
] as const;

export const { SortProvider: DestinationsSortProvider, useSort: useDestinationsSort } = createSearchSortContext(
  "Destinations",
  SORT_KEYS,
);
